<template>
  <super-admin-layout>
    <v-container>
      <v-row>
        <v-col md="12">
            <h4>Super Admin Dashboard</h4>
            <p>TBC</p>
        </v-col>
      </v-row>
    </v-container>
  </super-admin-layout>
</template>

<script>
import SuperAdminLayout from "@/layouts/SuperAdmin";

export default {
  name: "SuperAdminDashboard",
  components: {
    SuperAdminLayout
  }
};
</script>
